<template>
  <div>
    <v-form>
      <v-stepper v-model="step" vertical elevation="0" class="text-start pb-4">
        <v-stepper-items>
          <v-stepper-step :complete="step > 1" step="1">
            Válidação da conta
          </v-stepper-step>
          <v-stepper-content step="1">
            <ConcessionBiometryVerify @next="step = 2" />
          </v-stepper-content>

          <v-stepper-step :complete="step > 2" step="2">
            Benefício
            <small v-if="step > 2">
              {{ concessionTypes[concessionVerification.type].name }}
            </small>
          </v-stepper-step>
          <v-stepper-content step="2">
            <ConcessionTypeForm v-model="concessionVerification.type" />
            <div class="d-flex justify-end mt-4">
              <v-btn
                color="primary"
                @click="step = 3"
                :disabled="!concessionVerification.type"
              >
                Continuar
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="4">
            Documentos
          </v-stepper-step>
          <v-stepper-content step="3">
            <ConcessionFilesForm
              v-model="concessionVerification.files"
              :type="concessionVerification.type"
            />
            <div class="d-flex justify-space-between mt-4">
              <v-btn text @click="step = 2"> Voltar </v-btn>
              <v-btn
                color="primary"
                @click="step = 4"
                :disabled="!concessionVerification?.files?.documentFront"
              >
                Continuar
              </v-btn>
            </div>
          </v-stepper-content>

          <!-- <v-stepper-step :complete="step > 4" step="4">
            Análise
          </v-stepper-step> -->
          <!-- <v-stepper-content step="4">
            <ConcessionAllowAiForm
              v-model="concessionVerification.allowAi"
              :type="concessionVerification.type"
            />
            <div class="d-flex justify-space-between mt-4">
              <v-btn text @click="step = 3"> Voltar </v-btn>
              <v-btn
                color="primary"
                @click="step = 5"
                :disabled="concessionVerification.allowAi === null"
              >
                Continuar
              </v-btn>
            </div>
          </v-stepper-content> -->
          <v-stepper-step :complete="success" step="4">
            Finalização
          </v-stepper-step>
          <v-stepper-content step="4" class="pl-0">
            <ConcessionSaveForm
              :value="concessionVerification"
              @success="() => (success = true)"
              @finish="finish"
              @back="() => (step = 3)"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>
  </div>
</template>

<script>
import ConcessionBiometryVerify from "./ConcessionBiometryVerify.vue";
import ConcessionTypeForm from "./ConcessionTypeForm.vue";
import ConcessionFilesForm from "./ConcessionFilesForm.vue";
// import ConcessionAllowAiForm from "./ConcessionAllowAiForm.vue";
import ConcessionSaveForm from "./ConcessionSaveForm.vue";
import concessionTypes from "@/definitions/concessionTypes.json";

export default {
  name: "ConcessionForm",
  components: {
    ConcessionBiometryVerify,
    ConcessionTypeForm,
    ConcessionFilesForm,
    // ConcessionAllowAiForm,
    ConcessionSaveForm,
  },
  data() {
    return {
      concessionVerification: {
        type: null,
        files: null,
        allowAi: null,
      },
      step: 1,
      concessionTypes,
      success: false,
    };
  },
  methods: {
    finish() {
      this.$emit("finished");
    },
  },
};
</script>
